export const userlisadata = [
	{
		"id":1,
        "img":"assets/img/users/file.enc",
		"username": "Mohamed Kabani",
		"phone": "+216 22 947 145",
		"email": "kabanimo@gmail.com",
		"role": "ADMIN",
		"shops": "BR55, HO99, BV18,  MR15",
		"status": "Active",
		
	},
	{
		"id":2,
        "img":"assets/img/users/user-15.jpg",
		"username": "Foulen Ben Foulen",
		"phone": "+216 58 927 122",
		"email": "pg2@gmail.com",
		"role": "MANAGER",
		"shops": "BR55",
		"status": "Active",
		
	},
	{
		"id":3,
        "img":"assets/img/users/user-15.jpg",
		"username": "SANA XXXXXXXX",
		"phone": "+216 23 123 456",
		"email": "ASSISTANT MANAGER@gmail.com",
		"role": "ASSISTANT MANAGER",
		"shops": "BV18,  MR15",
		"status": "Active",
		
	},
	{
		"id":4,
        "img":"assets/img/users/user-15.jpg",
		"username": "Kylian MBAPPE",
		"phone": "+216 97 98 99 00",
		"email": "sellerzz@gmail.com",
		"role": "SELLER",
		"shops": "MR15",
		"status": "Active",
		
	},
	{
		"id":5,
        "img":"assets/img/users/user-15.jpg",
		"username": "Robert DE NIRO",
		"phone": "+216 22 947 145",
		"email": "sellerzz@gmail.com",
		"role": "SELLER",
		"shops": "MR15",
		"status": "Inctive",
		
	}
]